export const isDragonstone = (requisitionId: string) => {
  return requisitionId.toLowerCase().startsWith("job");
};
